<template>
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 22 22"
    :height="height"
    :width="width"
  >
    <g transform="translate(1, 1)">
      <g fill-rule="evenodd" fill="none" stroke-width="1" stroke="none" id="Symbols">
        <g
          :fill="iconColor ? iconColor : '#256AB3'"
          transform="translate(-2.000000, -2.000000)"
          id="icon/other/social/twitter"
        >
          <path
            id="icon"
            d="M12,2 C6.47666667,2 2,6.47708333 2,12 C2,17.523125 6.47666667,22 12,22 C17.5229167,22 22,17.523125 22,12 C22,6.47708333 17.5229167,2 12,2 Z M15.9761063,9.99209571 C15.9804466,10.0788293 15.9819658,10.1659902 15.9819658,10.2535783 C15.9819658,12.9224525 13.9181189,16 10.1445995,16 C8.98615421,16 7.9077888,15.6654561 7,15.092288 C7.16015973,15.111301 7.32335771,15.1207007 7.48915992,15.1207007 C8.45055231,15.1207007 9.33512012,14.7979064 10.0373923,14.2559282 C9.13958636,14.239906 8.38175742,13.6558428 8.12068404,12.8536637 C8.24612079,12.8769494 8.3745958,12.8899808 8.50676013,12.8899808 C8.69361314,12.8899808 8.87504069,12.8651997 9.04713644,12.8190558 C8.10874802,12.6334117 7.40126739,11.8173467 7.40126739,10.838496 C7.40126739,10.8299509 7.40126739,10.8216193 7.40170143,10.8132878 C7.6779661,10.9645375 7.99459624,11.0553301 8.33075805,11.0660115 C7.78018186,10.7036958 7.41819484,10.0856655 7.41819484,9.38474685 C7.41819484,9.01474044 7.51910849,8.66801965 7.69576163,8.36957915 C8.70750233,9.59154027 10.2194709,10.3954283 11.924586,10.479812 C11.889429,10.3319803 11.8716335,10.1777398 11.8716335,10.0194403 C11.8716335,8.90408032 12.7900562,8 13.9231103,8 C14.5131839,8 15.0463986,8.24524674 15.4205386,8.63768426 C15.8879967,8.54710532 16.3272423,8.37919248 16.7235183,8.14761803 C16.5700862,8.61909848 16.2449923,9.0151677 15.821589,9.26490066 C16.2365286,9.21597949 16.6319365,9.1076693 17,8.94701987 C16.7252545,9.35163427 16.3771566,9.70754112 15.9761063,9.99209571 Z"
            vector-effect="non-scaling-stroke"
            :fill="iconColor ? iconColor : '#38a1f3'"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "twitterIcon",
  props: ["height", "width", "iconColor"],
};
</script>

<style scoped>
</style>